<template>
  <div v-if="messages.length" class="tripleIconMessageContainer" :class="{grayBackground}">
    <div class="container">
      <h4 v-if="title" class="text-center">{{ title }}</h4>
      <div class="listWrapper" :class="{'quadMessage' : messages.length === 4}">
        <div
          v-for="(
            {
              icon,
              iconColor,
              iconBgColor,
              title,
              message
            }, index
          ) in messages"
          :key="index"
          class="iconMessage d-flex flex-column justify-content-start align-items-center text-left"
        >
          <div class="iconWrapper d-flex justify-content-center align-items-center text-left" :style="`background:${iconBgColor}`">
            <component v-bind:is="icon" :fill="iconColor" height="40px" width="40px" />
          </div>
          <div class="titleWrapper d-flex flex-column justify-content-center align-items-center">
            <span v-for="text in title" :key="text">
              {{ text }}
            </span>
          </div>
          <p v-html="message" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TripleIconMessage',
  props: {
    title: {
      type: String,
      required: false
    },
    grayBackground: {
      type: Boolean,
      required: false,
      default: true
    },
    messages: {
      type: Array,
      required: true,
    }
  }
};
</script>

<style lang="scss">
  @import '@sass/vue-imports.scss';

  .tripleIconMessageContainer {
    padding: 100px 0;
    &.grayBackground {
      background: $brand-lighter;
    }
    @include media-breakpoint-down(sm) {
      padding: 35px 0 5px;
    }

    h4 {
      margin-bottom: 100px;
      @include media-breakpoint-down(sm) {
        margin-bottom: 35px;
      }
    }

    .listWrapper {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 30px;

      &.quadMessage {
        grid-template-columns: repeat(4, 1fr);
        row-gap: 30px;

        @include media-breakpoint-down(md) {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      @include media-breakpoint-down(sm) {
        grid-template-columns: 1fr !important;
        column-gap: 0;

        .iconMessage {
          margin: 0 auto 30px;
          &:not(:last-of-type) {
            border-bottom: 1px solid $light-gray;
          }
        }
      }

      .iconMessage {
        max-width: 430px;

        .titleWrapper {
          min-height: 52px;
          >span {
            text-align: center;
            font-weight: 900;
            font-size: 26px;
            line-height: 26px;
            letter-spacing: 0.02em;
            text-transform: uppercase;
            color: $dark-gray;
          }
        }

        .iconWrapper {
          height: 70px;
          width: 70px;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 10px;
          margin-bottom: 24px;
        }

        p {
          margin-top: 20px;
        }
      }
    }
  }
</style>